import React from "react";
import ReactDOM from "react-dom";
import {
  ISpinnerStyles,
  Spinner,
  SpinnerSize,
} from "@fluentui/react/lib/Spinner";

const customSpinnerStyles: Partial<ISpinnerStyles> = {
  root: {
    position: "fixed",
    top: "45%",
    left: "10%",
    width: "80%",
    zIndex: 999999,
    overflow: "hidden",
  },
  // Fluent colors the ring via border-color, not `color`. Track stays light (white/grey)
  // in both themes; only the moving arc color switches so it stays visible against the track.
  circle: {
    borderWidth: "3.5px",
    borderTopColor: "var(--spinner-arc-color, #0078d4)",
    borderRightColor: "var(--spinner-track-color, #c8c8c8)",
    borderBottomColor: "var(--spinner-track-color, #c8c8c8)",
    borderLeftColor: "var(--spinner-track-color, #c8c8c8)",
  },
  label: { fontSize: "13px", fontWeight: 500, color: "var(--text-color, #333333)" },
};

const Backdrop = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        zIndex: 999999,
        // Theme-independent dim overlay; using the page background var here made the
        // backdrop nearly invisible since it matched the page's own color in both themes.
        background: "rgba(0, 0, 0, 0.45)",
      }}
    />
  );
};

const ProgressOverlay = () => {
  return (
    <div>
      <Spinner
        label="Loading..."
        size={SpinnerSize.large}
        styles={customSpinnerStyles}
      />
    </div>
  );
};

export default function LoadingScreen() {
  const backdrop = document.getElementById("backdrop-root")!;
  const overlay = document.getElementById("overlay-root")!;
  return (
    <>
      {ReactDOM.createPortal(<Backdrop />, backdrop)}
      {ReactDOM.createPortal(<ProgressOverlay />, overlay)}
    </>
  );
}
